import { API_SERVER } from 'config/constant';
import { getMethod, postMethod, putMethod ,urls,postMethodfile} from 'utils/url/urls';
const person = localStorage.getItem('user');
const user = JSON.parse(person);



export async function changePassword(id,data) {
    try {
      const response = await fetch(`${API_SERVER}${urls.changePasswordLearner}${id}`,putMethod(data));
      const result = await response.json();
      return result;
    } catch (err) {
      console.log('getCreator Error:', err);
    }
  }

  export async function learnerLogin(data) {
    try {
      const response = await fetch(`${API_SERVER}${urls.learnerLogin}`,postMethod(data));
      const result = await response.json();
      return result;
    } catch (err) {
      console.log('getCreator Error:', err);
    }
  }
  export async function learnerlogout(data) {
  try {
     const response = await fetch(`${API_SERVER}${urls.learnerlogout}`,postMethod(data));

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
}
  
  
// sundar
export async function checkLearner(data) {
  try {
    const response = await fetch(`${API_SERVER}${urls.checklearner}`, postMethod(data));
    const result = await response.json();
    return result;
  } catch (err) {
    console.log('getCreator Error:', err);
  }
}
  export async function updateLearnerTerms(id, data) {
  try {
    const person = localStorage.getItem('user');
    const currentUser = JSON.parse(person);
    const token = currentUser?.token;

    const response = await fetch(
      `${API_SERVER}${urls.updateLearner}${id}`,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }
    );
    const result = await response.json();
    return result;
  } catch (err) {
    console.log('updateLearnerTerms Error:', err);
  }
}

export async function microsoftLearnerVerify(data) {
  try {

    const response = await fetch(`${API_SERVER}${urls.microsoftLearnerVerify}`, postMethod(data));
   

    const result = await response.json();
   
    return result;
  } catch (err) {
    
    console.log('microsoftLearnerVerify Error:', err);
    return {
      status: 'Failure',
      message: 'Unable to verify Microsoft login. Please try again later.',
    };
  }
}